;
;
//
export var modelTerminal;
(function (modelTerminal) {
    modelTerminal["S1E"] = "S1E";
    modelTerminal["S1F2"] = "S1F2";
})(modelTerminal || (modelTerminal = {}));
export var statusOrder;
(function (statusOrder) {
    statusOrder["NEW"] = "new";
    statusOrder["ORDER_PLACED"] = "order_placed";
    statusOrder["IN_PROGRESS"] = "in_progress";
    statusOrder["SHIPPED"] = "out_for_delivery";
    statusOrder["RECEIVED"] = "received";
    statusOrder["CANCELLED"] = "cancelled";
})(statusOrder || (statusOrder = {}));
export var statusTerminal;
(function (statusTerminal) {
    statusTerminal["NEW"] = "new";
    statusTerminal["READY"] = "ready";
    statusTerminal["IN_USE"] = "in_use";
    statusTerminal["SUPPORT"] = "support";
    statusTerminal["DELETED"] = "deleted";
    statusTerminal["DECOMISSIONED"] = "decomissioned";
})(statusTerminal || (statusTerminal = {}));
